<template>
  <b-carousel :indicator="deviceWidth <= 960" :indicator-inside="false" animated="fade" :interval="interval" :autoplay="true" >
    <b-carousel-item v-for="(id, i) in slidesToUse " :key="i">
      <b-image class="image" :src="'https://drive.google.com/thumbnail?id=' + id + '&sz=w600'"></b-image>
    </b-carousel-item>
  </b-carousel>
</template>
<script>
export default {
  name: "ad-carousel",
  components: {
  },
  data() {
    return {
      interval: 5500,
    }
  },
  computed: {
    deviceWidth() {
      return this.$store.getters['device/deviceWidth'];
    },
    advertGoogleIds() {
      return this.$store.getters['generic/coPilotAdverts'];
    },
    slidesToUse() {
      if (this.deviceWidth < 1408) {
        return this.advertGoogleIds?.mobile;
      } else {
        return this.advertGoogleIds?.desktop;
      }
    }
  },
  mounted() {
    this.$store.dispatch('generic/coPilotAdverts');
  },
  methods: {

  },
}
</script>

<style lang="scss">
.is-active .al img {
  filter: grayscale(0%);
}
.al img {
  filter: grayscale(100%);
}

.carousel,
.carousel-items,
.carousel-item,
.image,
.image figure {
  max-height: 370px;
  height: 100% !important;
  width: 100% !important;
}

.image img {
  height: 100% !important;
  width: 100% !important;
  object-fit: cover !important;
}
</style>
